import { defineMessages } from 'react-intl'

const scope = `procurify.accounts-payable.page`

export default defineMessages({
  unbilledItemsPageTitle: {
    id: `${scope}.pageTitle`,
    defaultMessage: 'Unbilled items',
  },
  unbilledItemsTabName: {
    id: `${scope}.unbilledItemsTabName`,
    defaultMessage: 'Procurify | Unbilled items',
  },
})
